import React from 'react';
import './FilterLine.scss';

interface IFilterLine {
    code: string;
    label: string;
    updateFilters: Function; 
}

class FilterLine extends React.Component<IFilterLine, any> {

    render() {
        return (
            <div className="FilterLine">
                <label>
                    <input type='checkbox' className='checkboxFilter' value={this.props.code} onChange={(e) => this.props.updateFilters(this.props.code, e.target.checked)} />
                    {this.props.label}
                </label>
            </div>
        );
    }
}

export default FilterLine;